import * as actions from '@/domain/devices/actions';
import { devicesFactory } from '@/domain/devices/adapters';

export const reducer = {
  devices(state = devicesFactory([]), action) {
    switch (action.type) {
      case actions.getDevicesAction.success:
        return action.payload;
      default:
        return state;
    }
  },
};
